import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import VenturePage from './VenturePage';
import TradingPage from './TradingPage';
import LoadingScreen from './components/ui/LoadingScreen';
import './App.css';

gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    // Initialize any global animations or effects
    const sections = document.querySelectorAll('section');
    
    sections.forEach(section => {
      ScrollTrigger.create({
        trigger: section,
        start: 'top 80%',
        end: 'bottom 20%',
        toggleClass: { targets: section, className: 'active' }
      });
    });

    return () => {
      // Clean up ScrollTrigger when component unmounts
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <Router>
      <LoadingScreen />
      <Routes>
        <Route path="/" element={<VenturePage />} />
        <Route path="/trading" element={<TradingPage />} />
      </Routes>
    </Router>
  );
}

export default App;